export default __webpack_public_path__ + "static/B0095-d90976204c99da8c8c8775a53e8f3c22.png";